import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet } from 'react-native';
import { FormattedMessage } from '@dbk/format';

import { View, TouchableOpacity } from 'react-native';
// import Text from '../../common/text';
import Text from '@dbk/ui-text';
import Icon from './icon';
import styles, { editButtonIconColor } from './date-selection-bar.styles';

const defaultEditText = <FormattedMessage id="app.common.dateSelectionBar.edit" />;

function DateSelectionBar({
  editText,
  text,
  isEditable,
  onEditPress,
  isPymt,
  showIcon
}) {
  let myClass = isPymt ? styles.editButtonContainerPymt : styles.editButtonContainer;
  return ( 
    <View testID="date-selection-bar" style={[styles.root]}>
      <Text secondary size="small" testID="current-selection" className="current-selection" style={StyleSheet.flatten(styles.showText)}>
        { text }
      </Text>

      {isEditable && (
        <View testID="edit-button" style={myClass}>
          <TouchableOpacity onPress={onEditPress} style={styles.editButton}>
            { showIcon && 
              <Icon color={editButtonIconColor} />
            }
            <Text secondary size="small" style={StyleSheet.flatten(styles.editButtonText)} >
              {editText}
              </Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
}

DateSelectionBar.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.node.isRequired,
  ]).isRequired,
  editText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  isEditable: PropTypes.bool,
  onEditPress: PropTypes.func,
  showIcon: PropTypes.bool,
};

DateSelectionBar.defaultProps = {
  editText: defaultEditText,
  isEditable: false,
  showIcon: true,
  onEditPress: () => {},
};

export default DateSelectionBar;
